/**
    商品列表
**/
<template>
        <div class="rightaside_content">
          <h3 class="headerTitle">我的{{labelTitle}}</h3>
          <div class="headerButton">
              <span style="line-height: 28px;">订单号：<i>{{myRefundInfo.orderNumber}}</i></span>
              <!-- <div>
                    <el-button size="mini" @click="$router.push('/orderNow')">去支付</el-button>
                    <el-button size="mini" @click="cancleOrder">取消订单</el-button>
              </div> -->
          </div>
          <el-divider></el-divider>
          <div>
              <!-- <el-row class="order_goods" v-for="(item,index) in myRefundInfo.goodsItem" :key='index'>
                    <el-col :span="2"> <el-image :src="`${item.photos}`"></el-image></el-col> 
                    <el-col :span="15" class="order_Info_item">
                       <p>{{item.name}}</p>
                        <p>{{item.realprice}} 元 * {{item.number}}</p>
                    </el-col>
                </el-row> -->
                <el-row class="order_goods">
                    <el-col :span="2"> <el-image :src="`${myRefundInfo.goodsItem.photos}`"></el-image></el-col> 
                    <el-col :span="15" class="order_Info_item">
                        <p>{{myRefundInfo.goodsItem.name}} {{myRefundInfo.goodsItem.specificationlist.length!=0?myRefundInfo.goodsItem.specificationlist[0].name||' 默认规格':'默认规格'}}</p>
                        <p>{{myRefundInfo.goodsItem.realprice}} 元 * {{myRefundInfo.goodsItem.number}}</p>
                    </el-col>
                </el-row>

                <el-row v-if="type == ''">
                    <el-col :span="24" class="selectItem" @click.native="type=1">
                       <div class="selectItemIcon">¥</div>
                       <div class="selectItemText">
                           <p>我要退款(无需退货)</p>
                           <p class="selectItemTextSmall">没收到货，或与卖家协商同意不用退货只退款</p>
                       </div>
                    </el-col>
                    <div v-if="myRefundInfo.status >= 3">
                      <el-col :span="24">
                        <el-divider></el-divider>
                      </el-col>
                      <el-col :span="24"  class="selectItem" @click.native="type=2">
                        <div class="selectItemIcon">退</div>
                        <div class="selectItemText">
                          <p>我要退货退款</p>
                          <p class="selectItemTextSmall">货已发出，或已收到货，需要退还货物</p>
                        </div>
                      </el-col>
                      <el-col :span="24">
                        <el-divider></el-divider>
                      </el-col>
                      <el-col :span="24"  class="selectItem" @click.native="checkIsExchangeFunc">
                        <div class="selectItemIcon">换</div>
                        <div class="selectItemText">
                          <p>我要换货</p>
                          <p class="selectItemTextSmall">已收到货，需要更换已收到的货物</p>
                        </div>
                      </el-col>
                    </div>
                </el-row>
                <el-row class="myRefund" v-else>
                    <el-col :span="24"> <h3 class="headerTitle">{{labelTitle}}申请</h3></el-col>
                    <el-col>
                        <el-form  :rules="rules" ref="sizeForm" :model="sizeForm" label-width="150px" size="mini" >
                          <el-form-item label="更换规格" :required="true" v-if="type==3">
                            <div style="display: flex;">
                              <el-input disabled v-model="selectedSpecName"></el-input>
                              <el-button style="margin-left: 20px" @click="chooseAttr">选择规格</el-button>
                            </div>
                          </el-form-item>
                          <el-form-item label="更换数量" v-if="type==3 && selectedSpecId != ''">
                            <span>{{carNumber}}</span>
                          </el-form-item>
                          <el-form-item label="原商品价格" v-if="type==3 && originGoodsPrice != ''">
                            <span>{{originGoodsPrice}}</span>
                          </el-form-item>
                          <el-form-item label="换货商品价格" v-if="type==3 && exchangeGoodsPrice != ''">
                            <span>{{exchangeGoodsPrice}}</span>
                          </el-form-item>
                          <el-form-item :label="exchangeAmount>=0?'商家退款':'补差价'" v-if="type==3 && exchangeAmount != ''">
                            <span v-if="exchangeAmount>=0">{{exchangeAmount}}</span>
                            <span v-else style="color:#f00">{{Math.abs(exchangeAmount)}}</span>
                          </el-form-item>
                          <!--<el-form-item label="错误信息" v-if="type==3 && errorMsg != ''">-->
                            <!--<span style="color: #f00">{{errorMsg}}</span>-->
                          <!--</el-form-item>-->
                            <el-form-item :label="labelTitle+'原因'"  prop="reasaon">
                                <el-select v-model="sizeForm.reasaon" placeholder="请选择">
                                    <el-option v-for="item in reasaonList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="货物状态"  prop="reasaon" v-if="type==2">
                                <el-select v-model="sizeForm.returnType" placeholder="请选择">
                                    <el-option label="已收到货" value="1"></el-option>
                                    <el-option label="未收到货" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="退款金额" prop="amount" v-if="type!=3">
                                <el-input disabled v-model="sizeForm.amount"></el-input>
                            </el-form-item>
                            <el-form-item :label="labelTitle+'说明'"  prop="description">
                                <el-input v-model="sizeForm.description" placeholder="输入您的描述信息"></el-input>
                            </el-form-item>
                            <el-form-item :label="labelTitle+'凭证'" prop="" class="myproof">
                                <el-upload
                                        name="files"
                                        v-if="sizeForm.proof.length<3"
                                        class="avatar-uploader"
                                        :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                                        :show-file-list="false"
                                        :on-success="handleAvatarSuccess"
                                        :before-upload="beforeAvatarUpload">
                                         <i v-if="sizeForm.proof.length<3" class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <p style="color:red" v-if="sizeForm.proof.length<3">最多上传3张图片</p>
                                <div v-if="sizeForm.proof.length>0" class="uploadImg">
                                    <img  v-for="(item,index) in sizeForm.proof" :src="item" class="avatar" :key="index">
                                </div>
                            </el-form-item>
                            <el-form-item size="large">
                                <el-button v-if="isNewAddstatus==1" type="primary" @click="submitApply" size="mini" class="buttonBgd">申请{{labelTitle}}</el-button>
                                <el-button v-if="isNewAddstatus==2" type="primary" @click="editApply" size="mini" class="buttonBgd">确认修改</el-button>
                            </el-form-item>
                            </el-form>
                    </el-col>
                </el-row>               

          </div>

          <!-- 退款失败 -->
          <el-dialog
            v-if="attrDialogVisible"
            :visible.sync="attrDialogVisible"
            width="50%"
            center
            title="选择要更换的规格"
            onclose="onDialogClose"
            class="dialogBox">
            <div v-for="(item1,index) in attrList" :key="index">
              <goodsSizeItem :attributelist="item1" :goodsIdArr='goodsIdArr' :getgoodsSize='getgoodsSize'></goodsSizeItem>
            </div>
            <div class="ks" style="display: flex;align-items: center;margin-top: 20px">
              <div class="kuanshi fl">数量 :</div>
              <div class="number fl">
                <el-input-number v-model="carNumber" :min="1" :max="999" @change="change"></el-input-number>
              </div>
            </div>
            <div class="buygoods" style="display: flex;margin-top: 20px;">
              <el-button type="primary" @click="submitSpecification">确认</el-button>
              <el-button @click="cancleSpecification">取消</el-button>
            </div>
          </el-dialog>

          <!-- 退款失败 -->
           <el-dialog
            :visible.sync="backdialogVisible"
            width="30%"
            center
            class="dialogBox">
            <div class="textCenter">{{msg}}</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="backdialogVisible=false" class="buttonBgd">确 定</el-button>
            </span>
        </el-dialog>

        </div>
</template>
<script>
import {backMoney,xy_personvalue,addbackMoney,getDictData,returnAmount,editbackMoney,backMoneyList,checkIsExchange,getAttributelist,getSpecificationDetail,exchangeAmount} from '@/api/xunyou'
import goodsSizeItem from '@/components/goodsSize' // 商品规格
export default {
  data() {
    return {  
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        type: '', //0首页,1退款,2退货退款,3换货
        labelTitle: '退款',
        status:0,//1退款2退款修改
        msg:'',
        backdialogVisible:false,
         myRefundInfo:JSON.parse(sessionStorage.getItem("myRefundInfo")) || [],
         urlImg:'', // 用来图片预览的
        sizeForm: {
            reasaon:'',
            amount:JSON.parse(sessionStorage.getItem("myRefundInfo")).amount,
            description:'',
            proof:[],
            returnType:''
        },
      attrDialogVisible: false,
      attrList: [],
      errorMsg: '',
      carNumber: 1,
      selectedSpecId: '',// 选中的属性id
      selectedSpecName: '', // 选中的属性名称
      exchangeGoodsPrice: '', // 换货商品价格
      exchangeAmount: '', // 换货差价
      originGoodsPrice: '', // 原商品价格
      idArr: [],
      goodsIdArr: [],
        orderInfoList:{},
        reasaonList:[],
        isNewAddstatus:1,
         rules: {
           selectedSpecName: [{ required: true, message: "不能为空,请选择", trigger: ["blur", "change"] },],
            reasaon: [{ required: true, message: "不能为空,请选择", trigger: ["blur", "change"] },],
            amount:[ { required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            description:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            proof:[{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],          
        },
    }
  },
  // 注册组件
  components: {goodsSizeItem},
  watch: {
    type(newVal,oldVal) {
      this.labelTitle = newVal == 1?'退款':newVal == 2?'退货':newVal == 3?'换货':'退款'
    }
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
  },
  mounted(){
    if(this.$route.query.status==1){
        this.isNewAddstatus = 1
    }else{
        this.isNewAddstatus = 2
    }
      this.backReason()
      this.getreturnAmount()
      this.getbackMoneyList()
      
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    cancleSpecification() {
      this.attrDialogVisible = false
      this.clearExchangeData()
    },
    submitSpecification() {
      this.attrDialogVisible = false
    },
    clearExchangeData() {
      this.errorMsg = ''
      this.carNumber = ''
      this.selectedSpecId = ''
      this.selectedSpecName = ''
      this.originGoodsPrice = ''
      this.exchangeGoodsPrice = ''
      this.exchangeAmount = ''
    },
    change() {
      if (this.carNumber != '' && this.selectedSpecId != ''){
        this.exchangeAmountFunc(this.selectedSpecId)
      }
    },
    // 选规格价格发生变化
    async getgoodsSize(ids){
      let that = this
      let temp = ''
      ids.forEach(item => {
        temp += item.name +','
        this.idArr.push(item.id);
      });
      if (temp.endsWith(',')){
        temp = temp.slice(0,temp.length-1);
      }
      this.selectedSpecName = temp;
      this.idArr = []
      ids.forEach((item)=>{
        this.idArr.push(item.id)
      })
      getSpecificationDetail({productId:this.myRefundInfo.goodsItem.id,specificationIds:this.idArr.toString(),muid:this.userInfo.userId||''})
        .then( res => {
          if (res.code == 0) {
            if(res.rows.length>0){
              that.selectedSpecId = res.rows[0].id
              that.exchangeAmountFunc(res.rows[0].id)
            }
          } else {
            that.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          that.$message.error('查询商品属性失败，请稍后再试！')
        })
    },
    exchangeAmountFunc(exchangeSid) {
      exchangeAmount({
        exchangeSid: exchangeSid,
        exchangeGoodsNum: this.carNumber,
        oid:this.myRefundInfo.oid,
        bxysid:this.myRefundInfo.goodsItem.specificationlist.length>0?this.myRefundInfo.goodsItem.specificationlist[0].id:0,
        uid:this.userInfo.userId||''
      }).then(res => {
        if(res.code == 0){
          this.originGoodsPrice = res.data.originGoodsPrice
          this.exchangeGoodsPrice = res.data.exchangeGoodsPrice
          this.exchangeAmount = res.data.exchangeAmount
        }else {
          this.$message.warning(res.msg)
        }
      })
    },
    chooseAttr() {
      this.clearExchangeData()
      // this.getAttr()
      this.attrDialogVisible = true
    },
    getAttr() {
      let that = this
      getAttributelist({
        productId:that.myRefundInfo.goodsItem.id
      }).then(res => {
        if(res.code == 0){
          this.attrList = res.rows
        }else {
          that.$message.warning(res.msg)
        }
      })
    },
    // 校验是否允许换货
    checkIsExchangeFunc(){
      let that = this
      checkIsExchange({
        oid:that.myRefundInfo.oid
      }).then(res => {
        if(res.code == 0){
          if (res.data == true){
            that.type=3
            that.getAttr()
            // this.clearExchangeData()
            // this.searchAllSpecification()
          }else {
            that.$message.warning('当前不允许换货')
          }
        }else {
          that.$message.warning(res.msg)
        }
      })
    },

    //   查询退款原因
    backReason(){
         getDictData({
             key:'b_xy_deal_after_sale_reason'
        }).then(res => {
              if (res.code == 0) {
                  this.reasaonList = res.data
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
        }) 
    },

    // 查询退款金额
    getreturnAmount(){
         returnAmount({
            oid:this.myRefundInfo.oid,
			bxysid:this.myRefundInfo.goodsItem.specificationlist.length>0?this.myRefundInfo.goodsItem.specificationlist[0].id:0,
        }).then(res => {
              if (res.code == 0) {
                  this.sizeForm.amount = Number(res.data).toFixed(2)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
        }) 
    },

     //   查询退款详情 （列表）
    getbackMoneyList(){
         backMoneyList({
            uid: this.userInfo.userId,
            asOid: this.myRefundInfo.goodsItem.returnOrder,
            bXyOasid:this.myRefundInfo.bXyOasid||'',
        }).then(res => {
              if (res.code == 0) {
                  this.orderInfoList = res.rows[0]
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
        }) 
    },

submitApply() {
      this.$refs.sizeForm.validate((valid) => {
        if (valid) {//  this.$router.push('/myOrder')
            const req = {
                uid:this.userInfo.userId,
                oid:this.myRefundInfo.oid,
                goodsId: this.myRefundInfo.goodsItem.id,
                type:this.type, // 申请类型 this.type,//1退款2退货退款
                refundAmount:this.sizeForm.amount, // 退款金额
                reason:this.sizeForm.reasaon, // 退款原因
                returnType:this.type==1?2:this.sizeForm.returnType, // 退货类型 1：需要退货，2.不用退货。 是否需要退货 没发货之前不需要退货
                remarks:this.sizeForm.description, // 退款说明
                bxysid:this.myRefundInfo.goodsItem.specificationlist.length>0?this.myRefundInfo.goodsItem.specificationlist[0].id:0,
                paymentProof:this.sizeForm.proof.toString()//图片
           }
           if (this.type == 3){
             req.returnType = 1
             req.exchangeSidName = this.selectedSpecName
             req.exchangeSid = this.selectedSpecId
             req.exchangeGoodsNum = this.carNumber
             req.exchangeGoodsId = this.myRefundInfo.goodsItem.id
             req.exchangeGoodsName = this.myRefundInfo.goodsItem.name
           }
           addbackMoney(req)
              .then(res => {
                  if(res.code == 0){
                      this.$router.push('/refund')
                       this.$message({
                          type: 'success',
                          message: res.msg
                      });
                       sessionStorage.removeItem("myRefundInfo")
                  }else{
                      this.msg = res.msg
                      this.backdialogVisible = true
                  }
              })
              .catch(err => {
                this.$message.error('提交失败，请稍后再试！')
              })
          } 
      });
    },

    // 修改
    editApply() {
      this.$refs.sizeForm.validate((valid) => {
        if (valid) {
            const req = {
                bXyOasid:this.orderInfoList.bXyOasid,
                uid:this.userInfo.userId,
                oid:this.myRefundInfo.oid,//
                goodsId: this.myRefundInfo.goodsItem.id,
                type:this.type, // 申请类型 this.type,//1退款2退货退款
                refundAmount:this.sizeForm.amount, // 退款金额
                reason:this.sizeForm.reasaon, // 退款原因
                returnType:this.type==1?2:this.sizeForm.returnType, // 退货类型 1：需要退货，2.不用退货。 是否需要退货 没发货之前不需要退货
                remarks:this.sizeForm.description, // 退款说明
                bxysid:this.myRefundInfo.goodsItem.specificationlist.length>0?this.myRefundInfo.goodsItem.specificationlist[0].id:0,//
                paymentProof:this.sizeForm.proof.toString(),//图片
                createTime:this.isNewAddstatus==2?new Date().getTime():'',//有值时，说明是重新申请
           }
          if (this.type == 3){
            req.returnType = 1
            req.exchangeSidName = this.selectedSpecName
            req.exchangeSid = this.selectedSpecId
            req.exchangeGoodsNum = this.carNumber
            req.exchangeGoodsId = this.myRefundInfo.goodsItem.id
            req.exchangeGoodsName = this.myRefundInfo.goodsItem.name
          }
         editbackMoney(req)
            .then(res => {
                if(res.code == 0){
                    this.$router.push('/refund')
                     this.$message({
                        type: 'success',
                        message: res.msg
                    });
                     sessionStorage.removeItem("myRefundInfo")
                }else{
                    this.msg = res.msg
                    this.backdialogVisible = true
                }
            })
            .catch(err => {
              this.$message.error('提交失败，请稍后再试！')
            })
          } 
      });
    },

    //   退款凭证上传
    handleAvatarSuccess(res, file) {
            this.urlImg = res.url; // 用来图片预览的
            this.sizeForm.proof.push(res.url);
        },
        beforeAvatarUpload(file) {
            // const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            // if (!isJPG) {
            // this.$message.error('上传头像图片只能是 JPG 格式!');
            // }
            if (!isLt2M) {
            this.$message.error('上传图片大小不能超过 2MB!');
            }
            return  isLt2M;
        }
  },

};
</script>

<style scoped lang="less">
    .rightaside_content{
        .el-divider--horizontal {
            display: block;
            height: 1px;
            width: 100%;
            margin: 5px 0;
        }
        .headerTitle{
            font-size: 20px;
            height: 40px;
            line-height: 40px;
            color: #666;
            margin-bottom: 20px;
        }
        .headerButton {
            display: flex;
            justify-content: space-between;
            button.el-button.el-button--default.el-button--mini {
                // background: #78b942;
                // color: white;
                background: #f896521a;
                color: #78b942;
                border: 1px solid #78b942;
            }
            .el-button.el-button--mini:focus, .el-button.el-button--mini:hover {
                background: #78b942 !important;
                color: white !important;
            }
        }
        .order_goods.el-row {
            border-bottom: 1px solid#DCDFE6;
            padding: 20px;
            box-sizing: border-box;
        }
        .myRefund{
            padding: 40px 20px;
            box-sizing: border-box;
             /deep/input[disabled], input[disabled="disabled"], /deep/input[readonly], /deep/input[readonly="readonly"]{
                    background: white !important;
                }
                /deep/.el-select.el-select--mini {
                    width: 100%;
                }
              /deep/.avatar-uploader {
                        padding: 20px 0;
                        box-sizing: border-box;
                    }
                /deep/.el-upload.el-upload--text {
                        border: 1px solid #ccc;
                    }

                .avatar-uploader .el-upload {
                    border: 1px dashed #d9d9d9;
                    border-radius: 6px;
                    cursor: pointer;
                    position: relative;
                    overflow: hidden;
                }
                .avatar-uploader .el-upload:hover {
                    border-color: #409EFF;
                }
                .avatar-uploader-icon {
                    font-size: 28px;
                    color: #8c939d;
                    width: 178px;
                    height: 178px;
                    line-height: 178px;
                    text-align: center;
                }
                .avatar {
                    width: 160px;
                    height: 160px;
                    display: block;
                }
                .el-form-item.myproof.el-form-item--mini {
                    border-bottom: 1px solid #ccc;
                }
                 button.el-button.buttonBgd.el-button--primary {
                    background-color: #78b942;
                    border-color: #78b942;
                    font-size: 14px;
                    margin: 20px 0;
                }
                .uploadImg{
                    display: flex;
                    img{
                        border:1px dashed #ccc;
                        margin: 0px 10px 30px 0;
                    }
                }
        }
       
.textCenter {
                text-align: center;
                font-size: 25px;
            }
             button.el-button.buttonBgd.el-button--primary {
               background-color: #78b942;
               border-color: #78b942;
               font-size: 18px;
               margin: 20px 0;
           }
    }
.selectItem{
    display: flex;
    margin: 15px 20px;
    .selectItemIcon{
        line-height: 30px;
        text-align: center;
        font-size: 20px;
        height: 30px;
        width: 30px;
        -webkit-border-radius: 50%;
        border-radius: 50%;
        color: #E50F41;
        border: 0.5px solid #E50F41;
        margin: 4px 17px 0 0;
        cursor: pointer;
    }
    .selectItemText{
        font-size: 14px;
        cursor: pointer;
        .selectItemTextSmall{
                font-size: 12px;
                color: #999999;
                margin: 2px 0 0 0;
        }
    }
}

</style>

 
 




// WEBPACK FOOTER //
// src/views/myOrder/myRefund.vue